export default function Photos({ studio }) {
  const openGallery = index => {
    const srcs = studio.studioPhotos.map(({ url }) => url.large)
    h.openGallery(srcs, index)
  }
  return (
    <div className='flex flex-wrap'>
      { studio.studioPhotos.map(({ url }, index) => (
        <Photo
          key={ url.small }
          studio={ studio }
          photo={ url }
          onClick={ () => openGallery(index) }
        />
      ))}
    </div>
  )
}

const Photo = ({ studio, photo, onClick }) => (
  <div className='w-1/5 p-[2px] cursor-pointer' onClick={ onClick }>
    <C.Image
      src={ photo.small }
      className='pt-[100%]'
      alt={ studio.name }
    />
  </div>
)
